import {reactive} from "vue";


export interface IApontamentoEntidadeEvent {

    listenerApontamentoAtualizado: { value: { codigoEntidade: string } }

    emitApontamentoAtualizado(codigoEntidade: string): void

}


class ApontamentoEntidadeEvent implements IApontamentoEntidadeEvent {

    listenerApontamentoAtualizado = reactive({value: {codigoEntidade: "0"}});

    emitApontamentoAtualizado(codigoEntidade: string): void {
        this.listenerApontamentoAtualizado.value = {codigoEntidade: codigoEntidade}
    }

}

export default ApontamentoEntidadeEvent;

